global.config = {
  isAIG: false,
  isCAAA: false,
  isCompCalc: false,
};
